import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import { DuLieuHeThong } from 'api';

class DropDownChonHuongXuLyLanhDaoRequire extends React.Component {
  constructor(props, context) {
    super(props);
    this.state = {
      data: this.props.data
    }
  }

  componentDidMount() {
    if(this.props.data.length == 0) {
      DuLieuHeThong.actions.getHuongGiaiQuyetLD.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'huongGiaiQuyetCuaLanhDao',
            data: res.data || []
          }]
        })
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != this.props.data) {
      this.state.data = nextProps.data;
      this.setState({...this.state})
    }
  }

  onChange(e) {
    if (this.props.require) {

    } else {
      this.props.onChange(e);
    }
  }

  render() {
    return (
      <DropDown label="Hướng xử lý" options={this.state.data} keyName='giaTri' valueName='ten'
        onChange={this.onChange.bind(this)}
        require={this.props.require}
        selectedValue={this.props.selected}
        isValid={this.props.isValid}
        name={this.props.name}/>
    )
  }
}

DropDownChonHuongXuLyLanhDaoRequire.defaultProps = {
  selected: '',
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: '--Chọn--'
  },
  name: '',
  data: []
}

let bindStateToProps = state => {
  return {
    data: state.duLieuHeThong.huongGiaiQuyetCuaLanhDao
  }
}

export default connect(bindStateToProps)(DropDownChonHuongXuLyLanhDaoRequire);



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-chonhuongxulylanhdao.jsx